module.exports = __webpack_public_path__ + "img/STAVR.ac917bdb.png";